import styled from 'styled-components';
import { Spinner } from 'ui/spinner';
import { ErrorStatePageError } from 'ui/illustrations';
import { EmptyState } from 'ui/emptyState';
import { TextButton } from 'ui/button';
import { BUTTON_SIZES } from 'ui/button';
import { useDataSyncTranslations } from 'modules/dataSync/hooks/useDataSyncTranslations';
import { spacing } from 'ui/theme';

const LoadingContainer = styled.div`
  display: flex;
  height: ${spacing.x24};
  padding: 0px ${spacing.double};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
`;

const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
`;

const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const DataSyncLoadingState = () => {
  return (
    <LoadingContainer data-test="data-sync-loading-state">
      <Spinner size={36} />
    </LoadingContainer>
  );
};

export const DataSyncErrorState = ({ onRetry }: { onRetry: () => void }) => {
  const { t } = useDataSyncTranslations();

  return (
    <ErrorContainer data-test="data-sync-error-state">
      <EmptyState
        Illustration={ErrorStatePageError}
        title={t('states.error.title')}
        subtitle={
          <>
            {t('states.error.subtitle')}{' '}
            <TextButton onClick={onRetry} size={BUTTON_SIZES.MEDIUM}>
              {t('states.error.retry')}
            </TextButton>
          </>
        }
      />
    </ErrorContainer>
  );
};

export const DataSyncSuccessState = ({ children }: { children: React.ReactNode }) => {
  return <SuccessContainer data-test="data-sync-success-state">{children}</SuccessContainer>;
};
